"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../ts/lib/layout/navigation");
require("../../ts/lib/layout/blog-list");
require("../../ts/lib/layout/blog-list-footer");
require("./ts/components/video/video-layer");
const share_1 = require("./ts/components/social/share");
document.addEventListener('DOMContentLoaded', share_1.initSocialSharing);
